import React, { useState, useEffect } from 'react'
import { changePassword, validateChangePasswordForm } from 'src/utils';
import { Button, Box, TextFieldInput, Loader } from 'src/components';
import { ProfileViewHeader } from '../../index';

export default function ChangePassword({ handleCurrentViewChange, handleSuccess}) {
    const [loading, set_loading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [fieldErrors, setFieldErrors] = useState({});

    const timer = React.useRef();
    
    useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
    }, []);

    const handleChangePassword = async (e) => {
        e.preventDefault();
        set_loading(true);
        setErrorMsg("");
        setFieldErrors({});
        
        const data = e.target;
        const { errors, isValid } = validateChangePasswordForm(data.currentPassword.value, data.newPassword.value);
        if (!isValid) {
            setFieldErrors(errors);
            set_loading(false);
            return;
        }

        timer.current = window.setTimeout(async () => {
            try { 
                await changePassword(data.currentPassword.value, data.newPassword.value);
                handleSuccess("Password changed successfully!");
                handleCurrentViewChange("AccountSummary");
            } catch (err) {
                setErrorMsg(err.message || 'Password change failed');
            }
            set_loading(false);
        }, 1000); 
    };

    return (
        <Box className="change-password-box box">
            <ProfileViewHeader title="Change Password" subtitle="Confirm your current password and provide a new one" handleCurrentViewChange={handleCurrentViewChange} backTo="AccountSummary" />

            <Box component="form" onSubmit={handleChangePassword} sx={{ mt: 1 }}>

                <TextFieldInput 
                    id="currentPassword" 
                    label="Current Password" 
                    autoFocus={true} 
                    type="password"
                    error={!!fieldErrors.currentPassword}
                    helperText={fieldErrors.currentPassword}/>

                <TextFieldInput 
                    id="newPassword" 
                    label="New Password" 
                    type="password"
                    error={!!fieldErrors.newPassword}
                    helperText={fieldErrors.newPassword}/>

                {errorMsg && (
                    <Typography variant="body3" color="error">{errorMsg}</Typography>
                )}

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                    sx={{ mt: 1, mb: 1 }}
                    className="submit-button button">
                        Submit
                </Button>

                {loading && (<Loader />)}

            </Box>
        </Box>
    )}
